
import CommonUtils from "@/common-utils";
import CommonImageViewer from "@/components/CommonImageViewer.vue";
import UgcProfile from "@/components/UgcProfile.vue";
import UgcReportForm from "@/components/UgcReportForm.vue";
import Constants from "@/constants";
import { SlvUgcReplyOVO, UgcPickProductVO, UgcReplyOVO, UgcVO } from "@/views/biz/ugc/vo/ugc.vo";
import axios from "axios";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Teleport from "vue2-teleport";
import BottomSheets from "./BottomSheets.vue";

@Component({
  components: { CommonImageViewer, Teleport, UgcProfile, BottomSheets, UgcReportForm },
})
export default class UgcDetailComponent extends Vue {
  @Prop() propUgc!: UgcVO;
  @Prop() productCd!: string;
  @Prop({ default: false }) isDetail!: boolean;
  @Prop() refresh!: Function;

  // 상품 이미지 swiper
  swiperReviewImgOptions = {
    slidesPerView: 1,
    lazy: true,
    loop: false,
    freeMode: false,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
  };

  swiperFeedKeywordOptions = {
    slidesPerView: "auto",
    spaceBetween: 6,
  };

  //ugc products
  swiperUgcProducts = {
    slidesPerView: this.$isMobile ? 1.5 : 2.2,
    spaceBetween: this.$isMobile ? 1 : 10,
  };

  replyFormVO: SlvUgcReplyOVO = {} as SlvUgcReplyOVO;

  currentReplyVO = {} as SlvUgcReplyOVO;

  //대댓글일때 활성화
  isRereply = false;
  ugcReply: UgcReplyOVO = {} as UgcReplyOVO;
  // replies: Array<SlvUgcReplyOVO> = [];

  // 골라주떼요
  pick = {} as UgcPickProductVO;
  // 골라주세요 남은 시간
  remainDate = {} as { days: number; hours: number };
  //댓글 더보기 버튼
  busy = true;
  sliderValue3 = 4;
  sliderDefaultOptions = {
    min: 0,
    dotSize: 6,
    width: "auto",
    height: 6,
    contained: false,
    direction: "ltr",
    data: null,
    dataLabel: "label",
    dataValue: "value",
    interval: 1,
    disabled: false,
    clickable: true,
    duration: 0.5,
    adsorb: false,
    lazy: false,
    tooltip: "none",
    tooltipPlacement: "top",
    tooltipFormatter: void 0,
    useKeyboard: false,
    keydownHook: null,
    dragOnClick: false,
    enableCross: true,
    fixed: false,
    minRange: void 0,
    maxRange: void 0,
    order: true,
    marks: false,
    dotOptions: void 0,
    dotAttrs: void 0,
    process: true,
    dotStyle: { backgroundColor: "transparent !important", border: "2px solid transparent !important" },
    railStyle: void 0,
    processStyle: { backgroundColor: "#ff699b" },
    tooltipStyle: void 0,
    stepStyle: void 0,
    stepActiveStyle: void 0,
    labelStyle: void 0,
    labelActiveStyle: void 0,
  };

  $commonUtils = CommonUtils; // 이거 안하면 왜 오류나는지 모르겠음. App.vue 에서 prototype에 선언해줘도 뭐라고 함. 파서 오류 같음

  //-------------------------------
  // methods
  //-------------------------------

  // 이미지 전체화면 보기
  // showFullscreenImage(review: ReviewVO) {
  //   this.$router.push({ name: "ImageViewer", params: { images: review.files as any } });
  // }

  //computed
  get ugc() {
    return this.propUgc;
  }

  //리뷰 : 01 , 피드 : 02 카테고리 불러올때 사용됨 , 톡톡: 03
  get ugcType() {
    switch (this.ugc.ugcTypeCd) {
      case "047001":
        return "01";
      case "047002":
        return "02";
      case "047011":
        return "03";
      default:
        return "";
    }
  }

  // 톡톡 게시판 여부
  get isTalkTalk() {
    return this.ugc.ugcTypeCd == "047011";
  }

  // 골라주세요 종료까지 남은 일자
  get getRemainDays() {
    if (!this.ugc.endDate || this.ugc.boardTypeCd != "055003") {
      return null;
    }

    if (!this.remainDate.days) {
      return null;
    }

    if (this.remainDate.days <= 0) {
      return null;
    }

    return this.remainDate.days;
  }

  // 골라주세요 종료까지 남은 시간
  get getRemainHours() {
    if (!this.ugc.endDate || this.ugc.boardTypeCd != "055003") {
      return null;
    }

    if (!this.remainDate.hours) {
      return null;
    }

    if (this.remainDate.hours <= 0) {
      return null;
    }

    return this.remainDate.hours;
  }

  // 많이 고른거
  get maxPickCount() {
    if (this.ugc.boardTypeCd != "055003") {
      return 0;
    }
    const picks = this.ugc.products.map((item) => {
      return item.pickCount;
    });

    if (picks.length == 0) {
      return 0;
    }

    const maxPickCount = Math.max(...picks);

    // 고른 사람이 하나도 없다면
    return maxPickCount == 0 ? -1 : maxPickCount;
  }

  get isLogin() {
    return this.$session.has(Constants.MEMBER_INFO);
  }

  // textarea 개행 문자 변경. \n -> <br>
  // <! 포함시 주석처리 되는것을 방지하는 코드 추가
  getConvertedUgcText(text: string) {
    if (!text) {
      return;
    }
    const replacedText = text.replace(/<!/g,'< !');
    return replacedText.replace(/\n/g, "<br/>");
  }

  // 좋아요
  btnLike(item: UgcVO) {
    const params = { targetCd: item.ugcCd, ugcTypeCd: this.ugc.ugcTypeCd };
    if (item.liked == 0) {
      axios.post(`/ugc/like`, params).then(() => {
        item.liked = 1;
        item.likeCount++;
        return;
      });
      return;
    }
    axios.delete(`/ugc/like`, { params }).then(() => {
      item.liked = 0;
      item.likeCount--;
      return;
    });
  }

  // review 목록

  onLayoutUpdated() {
    this.$nextTick(() => {
      this.$emit("layout-update");
    });
  }

  // watch 대댓글 활성화
  @Watch("replyFormVO.parentReplyCd")
  onKeywordChanged() {
    this.isRereply = this.replyFormVO.parentReplyCd ? true : false;
  }

  // 댓글 초기화
  clearReplyForm() {
    this.replyFormVO = {} as SlvUgcReplyOVO;
  }

  // 댓글수정버튼
  modifyReply(item: SlvUgcReplyOVO): void {
    BottomSheets.closeAll();

    if (item.isMyReply == true && "055005" == this.ugc.boardTypeCd && item.isSelected == true) {
      // 채택된 답변은 수정이 불가합니다.
      alert(this.$t("ugc.a0010"));
      return;
    }

    this.replyFormVO = Object.assign({}, item);
    (this.$refs.refContents as HTMLInputElement).focus();
  }

  // 댓글 수정
  updateReplyForm() {
    if (confirm(this.$t("review.c0003").toString())) {
      axios.put(`/ugc/reply`, this.replyFormVO).then(() => {
        this.getReply(true);
        this.$store.commit("touchKeepAlive");
      });
    }
  }

  // 답글쓰기
  setReplyParentCd(item: SlvUgcReplyOVO): void {
    this.replyFormVO = {} as SlvUgcReplyOVO;
    this.replyFormVO.parentReplyCd = item.replyCd;
    this.replyFormVO.memNickNm = item.memNickNm;
    (this.$refs.refContents as HTMLInputElement).focus();
  }

  // 댓글 저장
  submitReplyForm(): void {
    if (!this.replyFormVO.text) {
      // "a0009": "내용을 입력해 주세요",
      return alert(this.$t("review.a0009").toString());
    }

    // 수정이라면
    if (this.replyFormVO.replyCd) {
      this.updateReplyForm();
      return;
    }

    // 기본값 세팅
    this.replyFormVO.ugcCd = this.ugc.ugcCd;

    axios.post(`/ugc/reply`, this.replyFormVO).then(() => {
      this.getReply(true);
      this.$store.commit("touchKeepAlive");
    });
  }

  // get reply list
  getReply(reset: boolean): void {
    if(reset) {
      this.ugcReply.replies = [] as Array<SlvUgcReplyOVO>;
    }
    const params = {
      ugcCd: this.ugc.ugcCd,
      ugcTypeCd: this.ugc.ugcTypeCd,
      pageStart: this.ugcReply.replies? this.ugcReply.replies.length : 0,
      pageSize: 20,      
    };

    axios.get(`/v2/ugc/replies`, { params: params }).then((r) => {
      this.ugcReply.replies = this.ugcReply.replies.concat(r.data.replies as Array<SlvUgcReplyOVO>);
      this.ugc.replyCount = r.data.replyCount;
      
      this.replyFormVO = {} as SlvUgcReplyOVO;
      this.replyFormVO.ugcCd = this.ugc.ugcCd;
      //더보기 
      if(this.ugcReply.replies.length >= this.ugc.replyCount) {
        this.busy =false;
      }
    });
  }

  // 신고하기 콜백
  reportCallback(r: any, ugcCd: number) {
    // 아무작업도 안했을 때
    if (r == null) {
      return;
    }
    // 접수 되었습니다.
    alert(this.$t("review.a0005").toString());
    // 1: 신고 게시물 비공개 처리, 0: 신고 접수만 완료
    if (r.data) {
      this.blindReply(ugcCd);
    }
  }

  // 댓글 삭제
  deleteReply(reply: SlvUgcReplyOVO) {
    if (reply.isMyReply == true && "055005" == this.ugc.boardTypeCd && reply.isSelected == true) {
      // 채택 답변은 삭제가 불가합니다.
      alert(this.$t("ugc.a0014"));
      return;
    }

    // c0005": 댓글을 삭제하시겠습니까?
    if (confirm(this.$t("feed.c0005").toString()) == false) {
      return;
    }

    BottomSheets.closeAll();

    axios.delete("/ugc/reply", { data: reply }).then((r) => {
      // 삭제되었습니다.
      alert(this.$t("review.a0019"));
      this.refresh();
      this.blindReply(reply.replyCd);
    });
  }

  // 게시물 가림(삭제 또는 신고만)
  blindReply(replyCd: number) {
    this.ugcReply.replies.forEach((item) => {
      if (item.replyCd == replyCd || item.parentReplyCd == replyCd) {
        // 많이 지워지면 아래 여백이 넓어지는데 이거 해결하려면 Main.vue 까지 먹이를찾아산기슭을어슬렁거리는하이에나를타고깊은밤을날ㅇㄴ애려ㅑㅗ냉0ㅔㄹ9-
        this.$set(item, "isBlind", true);
        this.$store.commit("touchKeepAlive");
      }
    });
  }
  // 사용자 신고
  // @param isBlind: 차단임?
  blindMember(item: SlvUgcReplyOVO, isBlind?: boolean) {
    // 선택한 사용자의 게시물이 목록에서 제외됩니다. 진행하시겠습니까?
    if (isBlind && confirm(this.$t("feed.c0001").toString()) == false) {
      return;
    }
    // 047001: 리뷰, 047002: 피드, 047003: 사용자'
    axios.post("/ugc/report", { ugcTypeCd: "047003", targetCd: item.memCd }).then(() => {
      this.$set(item, "isBlind", isBlind);
      this.$store.commit("touchKeepAlive");
      BottomSheets.closeAll();
    });
  }

  // 고르기
  pickProduct() {
    if (!this.pick.pickSeq) {
      // 항목을 선택해 주세요.
      alert(this.$t("ugc.a0004"));
      return;
    }

    axios.post(`/ugc/${this.ugc.ugcCd}/pick/${this.pick.pickSeq}`).then((r) => {
      // 새로고침
      this.refresh();
    });
  }

  // 투표율
  getVoterTurnout(pickCount: number) {
    const result = Math.floor((pickCount / this.ugc.totalPickCount) * 100);

    if (!result) {
      return 0;
    }
    return result;
  }

  // 채택하기
  selection(reply: SlvUgcReplyOVO) {
    // 본 댓글을 채택답변으로 선정하시겠습니까?
    if (confirm(this.$t("ugc.c0001").toString()) == false) {
      return;
    }

    axios.post(`/ugc/${this.ugc.ugcCd}/kin/${reply.replyCd}`).then((r) => {
      // 채택 답변으로 선정되었습니다.
      alert(this.$t("ugc.a0008"));

      this.getReply(true);
      this.$store.commit("touchKeepAlive");
    });
  }

  // 포인트 타입코드로 포인트 정책 조회
  getPointPolicyByPointTypeCd(pointTypeCd: string, boardTypeCd: string) {
    const policy = this.ugc.ugcPointPolicys.filter((v) => v.pointTypeCd == pointTypeCd && v.boardTypeCd == boardTypeCd);

    if (!policy.length) {
      return "";
    }
    return CommonUtils.toPrice(policy[0].pointVal);
  }

  showFullscreenImage(ugc) {
    // 상세화면이면
    if (this.isDetail == true) {
      this.$set(ugc, "showFullscreenImage", true);
      return;
    }

    // 목록이면 상세로 이동
    this.$router.push({ name: "UgcDetail", params: { ugcCd: ugc.ugcCd } });
  }

  // 리스트에서는 라우터, 상세에서는 클릭이벤트
  onPickProducts(ugc: UgcVO) {
    if (this.isDetail == false) {
      this.$router.push({ name: "UgcDetail", params: { ugcCd: ugc.ugcCd.toString() } });
      return;
    }
  }
  // 상세에서 리스트 이동
  onProducts(ugc: UgcVO) {
    if (this.isDetail) {
      this.$router.push({ name:'Talks', params: { categoryCd: ugc.ugcCategoryCd.toString() } });
    } else {
      this.$emit('update:ugcCategoryCd', ugc.ugcCategoryCd);
    }
  }

  created() {
    // Prop으로 가져온거 부터
    if(this.isDetail){
      this.getReply(true);
    }
    // 골라주세요
    if (this.isTalkTalk == true && this.ugc.boardTypeCd == "055003") {
      this.remainDate = CommonUtils.remainDate(this.ugc.endDate);
    }
  }
}
